module.exports = __webpack_public_path__ + "static/media/camera.d4bdaa38.svg";